import { Component, Inject, OnInit, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-stack-color-edit',
  templateUrl: './stack-color-edit.component.html',
  styleUrls: ['./stack-color-edit.component.scss']
})
export class StackColorEditComponent implements OnInit, AfterViewInit {
  public allowSave = false;
  public fieldMessage = {};
  public hideColorSelect = true;

  constructor(
    public dialogRef: MatDialogRef<StackColorEditComponent>,    
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  
  ngOnInit(): void {
    this.data.tableDef.fields.forEach(item => {
      const { readonly, name } = item;
      if (!readonly) {
        this.fieldMessage[name] = '';
      }
    });
  }

  ngAfterViewInit(): void {
    if (!this.data.data.color) {
      const ele = document.getElementById('select-stack-color') as any;
      if (ele) {
        setTimeout(() => {
          ele.value = '#ffffff';
          this.hideColorSelect = false;
        }, 100);
      }
    } else {
      this.hideColorSelect = false;
    }
  }

  onChange() {
    let valid = true;
    this.data.tableDef.fields.forEach(x => { 
      const { readonly, name, required } = x;
      if (!readonly) {
        this.fieldMessage[name] = '';
        const data = (this.data.data[name] || '').trim();
        if(required && (data.length === 0)){
          valid = false;        
          this.fieldMessage[name] = 'Field is required';
        }
      }  
    });

    this.allowSave = valid;
  }

  save():void {
    if(!this.allowSave) {
      return;
    }
    this.dialogRef.close({...this.data.data});
  }

  close() {
    this.dialogRef.close('cancel');
  }
}
